import { useCallback, useMemo, useState } from 'react';
import { useAxios } from '@nexelem/utils';

const useAbortController = () => {
  const [reset, setReset] = useState(0);

  const controller = useMemo(() => new AbortController(), [reset]);

  const abort = useCallback(() => {
    controller.abort();
    setReset((val) => val + 1);
  }, [controller]);

  return { signal: controller.signal, abort };
};

export enum UploadStatus {
  IDLE = 'IDLE',
  SUCCESS = 'SUCCESS',
  LOADING = 'LOADING',
  ERROR = 'ERROR',
}

export const useUploadFile = (url: string) => {
  const [status, setStatus] = useState<UploadStatus>(UploadStatus.IDLE);
  const [progress, setProgress] = useState(0);
  const { signal, abort } = useAbortController();
  const axios = useAxios();

  const uploadForm = async (formData: FormData) => {
    setStatus(UploadStatus.LOADING);

    try {
      await axios.post(url, formData, {
        signal,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        onUploadProgress: (progressEvent) => {
          const progress = progressEvent.total ? Math.floor((progressEvent.loaded / progressEvent.total) * 100) : 0;
          setProgress(progress);
        },
      });

      setStatus(UploadStatus.SUCCESS);
    } catch (error) {
      if (signal.aborted) {
        setStatus(UploadStatus.IDLE);
      } else {
        setStatus(UploadStatus.ERROR);
      }
    }
  };
  return { uploadForm, status, setStatus, progress, abort };
};
